import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { loadAssetsThunk } from './assetsThunks'
import { ApiAsset } from '../../services/asset/asset-models'

interface AssetsState {
  list: ApiAsset[]
  loading: boolean
  error: string | null
  selectedAssetId: number | null
  loaded: boolean
}

const initialState: AssetsState = {
  list: [],
  loading: false,
  error: null,
  selectedAssetId: null,
  loaded: false
}

const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    setSelectedAssetId(state, action: PayloadAction<number | null>) {
      state.selectedAssetId = action.payload
    },

    // 👇 Add this reducer
    updateAssetInList(state, action: PayloadAction<ApiAsset>) {
      const updated = action.payload
      const index = state.list.findIndex(a => a.id === updated.id)
      if (index !== -1) {
        state.list[index] = updated
      } else {
        // Optional: add if not found (depends on API behavior)
        state.list.push(updated)
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAssetsThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(loadAssetsThunk.fulfilled, (state, action) => {
        state.loading = false
        state.list = action.payload
        state.loaded = true
      })
      .addCase(loadAssetsThunk.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to load assets'
      })
  },
})

export default assetsSlice.reducer
export const { setSelectedAssetId, updateAssetInList } = assetsSlice.actions
